import { GET_SEGMENTACION, ADD_SEGMENTACION, MODIFY_SEGMENTACION, DELETE_SEGMENTACION, UPDATE_SEGMENTACION } from '../constants/action_types';

const initialState = {
    segmentacionList: [],
    isLoading: false
};

// export function getFieldDescr(value)
// {
//     const tipos = ['','Saldo tarjeta','Dias sin uso', 'Núm. Tarjeta (concreta)', 'Where genérico'];
//     return tipos[value ? value : 0]
// }

// export function getOperatorDescr(value)
// {
//     const tipos = ['','igual a...','mayor que...', 'menor que...', 'entre...y...'];
//     return tipos[value ? value : 0]
// }

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_SEGMENTACION:
            
            return {
                ...state, centroId: action.meta,
                isLoading: true
            };

        case GET_SEGMENTACION + "_SUCCESS":
        
            return {
                segmentacionList: action.payload.data,
                isLoading: false
            };
            // const newSegList = [...action.payload.data];
            // newSegList.forEach(s => {
            //     const newObs = [...s.dcSegmentacionLinea];
            //     newObs.forEach(o => {
            //         o.operatorDescr = getOperatorDescr(o.iOperator);
            //         o.fieldDescr = getFieldDescr(o.iField);
            //     });
            // }); 
            // return {
            //     segmentacionList: newSegList, // action.payload.data,
            //     isLoading: false
            // };

            // const newList = action.payload.data.map(p => {
            //     p.dcSegmentacionLinea.map(q=> {

            //     })
            //     return {...p, tipoPromocionDescr: getDescr(p.iTipoPromocion)}
            //  })
            // const newPromo = action.payload.data.map(p => {
            //     return {...p, tipoPromocionDescr: getDescr(p.iTipoPromocion)}
            //  })

            // return {
            //     promocionList: newPromo,
            //     isLoading: false
            // };


        case ADD_SEGMENTACION:
            
            const newArr = [...state.segmentacionList, action.payload]
            return {
                segmentacionList: newArr,
                isLoading: false
            };

        case MODIFY_SEGMENTACION:
            
            // Ejemplo de codificación sin estar asociada a una tabla CV_ => añade la descripción a cada item
            // return {
            //     promocionList: state.promocionList.map((p) => {
            //         if (p.id !== action.payload.id) 
            //             return p;
            //         else
            //             return {...action.payload, tipoPromocionDescr: getDescr(action.payload.iTipoPromocion)};
            //     }),
            //     isLoading: false
            // };
            return {
                segmentacionList: state.segmentacionList.map((p) => {
                    if (p.id !== action.payload.id) 
                        return p;
                    else
                        return action.payload;
                }),
                isLoading: false
            };

        case DELETE_SEGMENTACION:

            return {
                segmentacionList: state.segmentacionList.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_SEGMENTACION + "_SUCCESS":

            return state;

        default:

            return state;
    }
}